export default __webpack_public_path__ + "9ef06d7d6bdd0faa3f2ede76fe5d7cf9.png";